import { Controller } from "@hotwired/stimulus"

// Two shapes, because the server reads the zone in two places. On a field it is submitted with
// the form; on a form it goes into the action's query string, which is the only thing the OmniAuth
// request phase keeps and hands back to the callback that opens the account.
export default class extends Controller<HTMLFormElement | HTMLInputElement> {
  connect() {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

    if (this.element instanceof HTMLFormElement) {
      const action = new URL(this.element.action, window.location.origin)
      action.searchParams.set("time_zone", timeZone)

      this.element.action = action.toString()
    } else {
      this.element.value = timeZone
    }
  }
}
